export const isGiftCardGroup = (giftCard) => 'groupId' in giftCard;
